import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Link from "@material-ui/core/Link";

import customSelectStyle from "assets/jss/material-kit-pro-react/customSelectStyle.js";
import Typography from "@material-ui/core/Typography";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center",
  },
  ...customSelectStyle,
};

class Step3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      simpleSelect: "",
      desgin: false,
      code: false,
      develop: false,
    };
  }
  sendState() {
    return this.state;
  }
  handleSimple = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  isValidated() {
    return true;
  }
  render() {
    const { classes } = this.props;

    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12}>
          <h2 className={classes.infoText} style={{ fontWeight: "400" }}>
            ¡Felicidades!
          </h2>
        </GridItem>
        <GridItem xs={10}>
          {!this.props.isExtraButtonDone ? (
            <Typography
              variant={"body2"}
              // component={"h5"}
              style={{ textAlign: "justify" }}
              gutterBottom
            >
              Estimado cliente, su certificado ha sido descargado
              satisfactoriamente en la carpeta designada. Si usted desea
              centralizar su certificado en la nube del Servicio Impuesto
              Interno{" "}
              <Typography
                display={"inline"}
                style={{ fontWeight: "bold" }}
                variant={"inherit"}
              >
                (SII)
              </Typography>{" "}
              deberá presionar el botón{" "}
              <Typography
                display={"inline"}
                variant={"inherit"}
                style={{ fontWeight: "bold" }}
              >
                Centralizar
              </Typography>
              , en caso contrario deberá presionar el botón{" "}
              <Typography
                display={"inline"}
                variant={"inherit"}
                style={{ fontWeight: "bold" }}
              >
                Finalizar
              </Typography>{" "}
              para terminar el proceso de descarga de certificados.
            </Typography>
          ) : (
            <Typography
              variant={"body2"}
              // component={"h5"}
              style={{ textAlign: "justify" }}
              gutterBottom
            >
              Estimado cliente, su certificado ha sido descargado
              satisfactoriamente en la carpeta designada. Para terminar el
              proceso de descarga de certificados presione{" "}
              <Typography
                display={"inline"}
                variant={"inherit"}
                style={{ fontWeight: "bold" }}
              >
                Finalizar
              </Typography>{" "}
              .
            </Typography>
          )}

          <Typography
            style={{ textAlign: "center", margin: 10 }}
            variant={"body2"}
            gutterBottom
          >
            Si no sabes instalar el certificado, siga los pasos que le indicamos
            en el siguiente manual:
          </Typography>

          <div style={{ textAlign: "center" }}>
            <Link
              to="#"
              state="uno"
              style={{
                color: "#0F69C4",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={(e) => window.open(window.pdfManualFES, "_blank")}
            >
              <p>Manual Instalación Firma Simple</p>
            </Link>
          </div>
        </GridItem>
      </GridContainer>
    );
  }
}

Step3.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(style)(Step3);
